import React from 'react';
import { connect } from 'react-redux';
import { faAngleRight, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ResultStatus({ previewing, result }) {
  return (
    <td colSpan={result.row_values.length}>
      {result.action === 'A' && (
        <h5>
          {previewing ? 'Preview new row.' : 'New row added.'}
        </h5>
      )}

      {result.diff && !result.diff.any_non_equivalent_fields && (
        <h5>Row unchanged.</h5>
      )}

      {result.diff && result.diff.any_non_equivalent_fields && (
        <>
          <h5>
            {previewing ? 'Preview changes:' : 'Changes made:'}
          </h5>
          {result.diff.changed_fields.map((name) => {
            const row = result.diff[name];

            return row.changed && !row.equivalent ? (
              <div key={name}>
                <FontAwesomeIcon icon={faAngleRight} fixedWidth className="me-2" />
                <strong>{`${name}: `}</strong>
                {row.old}
                <FontAwesomeIcon icon={faArrowRight} fixedWidth className="mx-1" />
                {row.new}
              </div>
            ) : null;
          })}
        </>
      )}

      {result.missing_required_fields && (
        <>
          <h5>Missing Required Fields:</h5>
          {result.missing_required_fields.map((field) => (
            <div key={field}>
              <FontAwesomeIcon icon={faAngleRight} fixedWidth className="me-2" />
              {field}
            </div>
          ))}
        </>
      )}

      {result.invalid_field_values && (
        <>
          <h5>Invalid Field Values:</h5>
          {result.invalid_field_values.map(({ field, value, error }) => (
            <div key={field}>
              <FontAwesomeIcon icon={faAngleRight} fixedWidth className="me-2" />
              {field}
              <i>{` (${value}): `}</i>
              {error}
            </div>
          ))}
        </>
      )}

      {result.data_integrity_errors && (
        <>
          <h5>Data Integrity Error:</h5>
          {result.data_integrity_errors.map((field) => (
            <div key={field}>
              <FontAwesomeIcon icon={faAngleRight} fixedWidth className="me-2" />
              {field}
            </div>
          ))}
        </>
      )}

      {result.duplicate_row_errors && (
        <>
          <h5>Duplicate Row Error:</h5>
          <div>
            <FontAwesomeIcon icon={faAngleRight} fixedWidth className="me-2" />
            {result.duplicate_row_errors}
          </div>
        </>
      )}
    </td>
  );
}

const mapStateToProps = (store) => ({
  previewing: store.batch.previewing,
});

export default connect(mapStateToProps)(ResultStatus);
